import { centsToDollars } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class RefundLanguage extends React.Component {
  constructor(props) {
    super(props)

    // Bind methods to this
    this.confirmedCharge = this.confirmedCharge.bind(this)
    this.confirmedRefund = this.confirmedRefund.bind(this)
    this.adjustmentInfo = this.adjustmentInfo.bind(this)
    this.priceIncrease = this.priceIncrease.bind(this)
    this.priceDecrease = this.priceDecrease.bind(this)
    this.priceNoChange = this.priceNoChange.bind(this)
  }

  confirmedCharge() {
    if (this.props.status === "confirmed") {
      if (this.props.autoBill) {
        return (
          <span>
            {" "}
            A new charge of{" "}
            <strong>
              {centsToDollars(Math.abs(this.props.state.netPrice))}
            </strong>{" "}
            will be charged to the boater.{" "}
          </span>
        )
      } else {
        return (
          <span>
            {" "}
            No charge will be made until a credit card is added to this
            reservation.
          </span>
        )
      }
    } else {
      return (
        <span>
          {" "}
          No charge will be made until this reservation is confirmed.
        </span>
      )
    }
  }

  confirmedRefund() {
    if (this.props.status === "confirmed") {
      if (this.props.autoBill) {
        return (
          <span>
            {" "}
            A refund of{" "}
            <strong>
              {centsToDollars(Math.abs(this.props.state.netPrice))}
            </strong>{" "}
            will be discounted from the boater. You can change this amount to
            adjust the amount to refund the customer.
          </span>
        )
      } else {
        return (
          <span>
            {" "}
            No charge will be made until a credit card is added to this
            reservation.
          </span>
        )
      }
    } else {
      return (
        <span>
          {" "}
          No charge will be made until this reservation is confirmed.
        </span>
      )
    }
  }

  adjustmentInfo() {
    return (
      <span>
        ${this.props.state.adjustmentNetDollars} of this was previously reserved
        as an adjustment.
      </span>
    )
  }

  priceIncrease() {
    return (
      <div className="pricing-language">
        The amount due on the reservation you edited has increased from{" "}
        <strong>{centsToDollars(this.props.state.originalPrice)}</strong> to{" "}
        <strong>{centsToDollars(this.props.state.updatedPrice)}</strong>.
        {this.confirmedCharge()}
      </div>
    )
  }

  priceDecrease() {
    return (
      <div className="pricing-language">
        The amount due on the reservation you edited has decreased from{" "}
        <strong>{centsToDollars(this.props.state.originalPrice)}</strong> to{" "}
        <strong>{centsToDollars(this.props.state.updatedPrice)}</strong>.
        {this.confirmedRefund()} {this.adjustmentInfo()}
      </div>
    )
  }

  priceNoChange() {
    return (
      <div className="pricing-language">
        There has been no change in the amount due on the reservation at this
        time. You can update the reservation without charging or refunding the
        boater. {this.adjustmentInfo()}
      </div>
    )
  }

  render() {
    if (this.props.state.originalPrice === this.props.state.updatedPrice) {
      return this.priceNoChange()
    } else if (this.props.state.originalPrice < this.props.state.updatedPrice) {
      return this.priceIncrease()
    } else {
      return this.priceDecrease()
    }
  }
}

RefundLanguage.propTypes = {
  status: PropTypes.string.isRequired,
  autoBill: PropTypes.bool.isRequired,
  state: PropTypes.shape({
    originalPrice: PropTypes.number.isRequired,
    updatedPrice: PropTypes.number.isRequired,
    netPrice: PropTypes.number.isRequired,
    adjustmentNetDollars: PropTypes.string,
  }).isRequired,
}

export default RefundLanguage
